import { Injectable, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { IResponse } from 'src/models/response.model';
import { environment as ENV } from 'src/environments/environment';

// REF: https://jasonwatmore.com/post/2019/06/22/angular-8-jwt-authentication-example-tutorial
const _token_key = "user";


// TODO: 로그인 때에 AccountNum, AccountName을 받아와서 가지고 있을 것.
@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {

  private userSubject: BehaviorSubject<ITokenResponse>;
  public currentUser: Observable<ITokenResponse>;

  private headers: HttpHeaders;
  private apiUrl: string;

  constructor(private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    @Inject(PLATFORM_ID) private platformId: Object,
    private logger: NGXLogger) {
    this.apiUrl = baseUrl + 'api/Token';

    this.headers = new HttpHeaders();
    this.headers = this.headers.append('Content-type', 'application/json');

    this.userSubject = new BehaviorSubject<ITokenResponse>(JSON.parse(localStorage.getItem(_token_key)));
    this.currentUser = this.userSubject.asObservable();
  }

  ngOnDestroy(): void {
    this.userSubject.unsubscribe();
  }

  public get currentUserValue(): ITokenResponse {
    return this.userSubject.value;
  }

  public isAuthenticated(): boolean {
    return !!this.userSubject.value;
  }

  public login(email: string, password: string, rememberMe: boolean = false) {
    this.logger.log("Signing in as: " + email);
    let data = <ITokenRequest>{
      domain: ENV.domain,
      email: email,
      password: password,
      grantType: GrantType.password,
      refreshToken: '',
    };

    return this.http.post(this.apiUrl, data, { headers: this.headers })
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem(_token_key, JSON.stringify(user));
        this.userSubject.next(user as ITokenResponse);
        return user;
      }));
  }

  public refreshToken() {
    let data = <ITokenRequest>{
      domain: this.currentUserValue.domain,
      type: this.currentUserValue.type,
      email: this.currentUserValue.email,
      password: '',
      grantType: GrantType.refresh,
      refreshToken: this.currentUserValue.refresh_token,
    };

    return this.http.post(this.apiUrl, data, { headers: this.headers })
      .pipe(map((user: any) => {
        this.handleTokenResponse(user);
        return user;
      }));
  }

  private handleTokenResponse(user: any) {
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    localStorage.clear();

    localStorage.setItem(_token_key, JSON.stringify(user));
    this.userSubject.next(user as ITokenResponse);
    this.logger.log('currentUser', this.currentUserValue);
  }

  public logout() {
    // remove user from local storage to log user out
    localStorage.removeItem(_token_key);
    this.userSubject.next(null);
    this.logger.log("Log out");
  }
}

export interface ITokenResponse {
  domain: string,
  type: string,
  uid: string,
  token: string,
  email: string,
  name: string,
  role: string,
  depart: string,
  password: string,
  refresh_token: string,
  orgName: string,
  accountNum: string,
}

export interface ITokenRequest {
  domain: string,
  type: 'VENDOR' | 'BUYER',
  email: string,
  password: string,
  grantType: GrantType,
  refreshToken: string,  
}

export enum GrantType {
  password = 1,
  refresh = 2
}
